import React from 'react';
import { injectIntl, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import { MainTaskIcon, SubTaskIcon, ToDoIcon } from '@/shared/components/Icons';
import messages from './taskMessages';

const TaskIcon = ({ intl, taskLevel }) => {
  switch (taskLevel) {
    case 0:
      return <MainTaskIcon tooltip={intl.formatMessage(messages.Task)} />;
    case 1:
      return <SubTaskIcon tooltip={intl.formatMessage(messages.SubTask)} />;
    case 2:
      return <ToDoIcon className="margin5R" tooltip={intl.formatMessage(messages.ToDo)} />;
    default:
      return null;
  }
};

TaskIcon.propTypes = {
  intl: intlShape.isRequired,
};

TaskIcon.defaultProps = {};

export default injectIntl(TaskIcon);
